/*
  # для <img>
    # data-zoom
    # data-zoom-media="min, 991.98" !не обов'язково
  # для <елемент trigger>
    # data-zoom=".profession__image-ibg [data-zoom]" - selector <img target>
    
  # style ./modules/zoom.scss
*/

import { hideScrolling, showScrolling } from './helpers/hideScrolling.js'

document.addEventListener('click', click)
document.addEventListener('keydown', keydown)

const zoomIn = el => {
  el.classList.add('zoomed')
  hideScrolling()
}

const zoomOut = el => {
  el.classList.remove('zoomed')
  showScrolling()
}

function click(e) {
  const el = e.target
  if (el.closest('[data-zoom]')) zoomFS(el.closest('[data-zoom]'))
}

function keydown(e) {
  const $img = document.querySelector('[data-zoom].zoomed')
  if (e.keyCode === 27 && $img) {
    zoomOut($img)
  }
}

function getMediaQuery(data) {
  if (!!!data) return false

  const arrayData = data.split(', ')
  const mediaValue = `(${arrayData[0]}-width: ${+arrayData[1] / 16}rem)`
  const mediaQuery = window.matchMedia(mediaValue)

  return mediaQuery
}

function zoomFS(el) {
  const $img = !!el.dataset.zoom ? document.querySelector(el.dataset.zoom) : el
  const dataMedia = $img.dataset.zoomMedia

  const mediaQuery = getMediaQuery(dataMedia)

  if (!mediaQuery?.matches) return

  if (!$img.classList.contains('zoomed')) {
    zoomIn($img)
    return
  }
  zoomOut($img)
}
